import React, { useState } from "react";

const Contact = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  // 🔹 Replace with your Formspree endpoint
  const FORMSPREE_URL = "https://formspree.io/f/xpwkwyak"; // Example — change to your own

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const form = e.currentTarget;
    const data = new FormData(form);

    // Optional — basic validation
    const name = data.get("name")?.trim();
    const email = data.get("email")?.trim();
    const message = data.get("message")?.trim();
    const subject = data.get("subject")?.trim();

    if (!name || !email || !message) {
      setSubmitStatus({
        type: "error",
        message: "Please fill in all required fields (Name, Email, Message).",
      });
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch(FORMSPREE_URL, {
        method: "POST",
        body: data,
        headers: { Accept: "application/json" },
      });

      if (response.ok) {
        setSubmitStatus({
          type: "success",
          message: "Message sent successfully! We'll reply soon.",
        });
        form.reset();
      } else {
        setSubmitStatus({
          type: "error",
          message: "Failed to send message. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Formspree error:", error);
      setSubmitStatus({
        type: "error",
        message: "Something went wrong. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus(null), 6000);
    }
  };

  return (
    <section className="contact-area section--padding">
      <div className="container" style={{ marginTop: "70px" }}>
        <div className="row">
          {/* FORM SECTION */}
          <div className="col-lg-7">
            <div className="section-heading">
              <p className="section__meta">#get in touch</p>
              <h2 className="section__title">Need Any Help? Contact us</h2>
            </div>

            {/* STATUS MESSAGE */}
            {submitStatus && (
              <div
                style={{
                  padding: "15px",
                  marginBottom: "20px",
                  borderRadius: "5px",
                  backgroundColor:
                    submitStatus.type === "success" ? "#d4edda" : "#f8d7da",
                  color:
                    submitStatus.type === "success" ? "#155724" : "#721c24",
                  border: `1px solid ${
                    submitStatus.type === "success" ? "#c3e6cb" : "#f5c6cb"
                  }`,
                  fontWeight: 500,
                }}
              >
                {submitStatus.message}
              </div>
            )}

            {/* CONTACT FORM */}
            <div className="contact-form-action contact-form-item">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* Name */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <i className="la la-user form-icon" />
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        placeholder="Name *"
                        required
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <i className="la la-envelope-o form-icon" />
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        placeholder="Email *"
                        required
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <i className="la la-phone form-icon" />
                      <input
                        className="form-control"
                        type="tel"
                        name="phone"
                        placeholder="Number"
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>

                  {/* Subject */}
                  <div className="col-lg-6">
                    <div className="form-group">
                      <i className="la la-pencil-square form-icon" />
                      <input
                        className="form-control"
                        type="text"
                        name="subject"
                        placeholder="Subject *"
                        required
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>

                  {/* Message */}
                  <div className="col-lg-12">
                    <div className="form-group message-group">
                      <i className="la la-pencil form-icon" />
                      <textarea
                        className="form-control message-control"
                        name="message"
                        placeholder="Write your message here... *"
                        rows={5}
                        required
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>

                  {/* Submit */}
                  <div className="col-lg-12">
                    <div className="form-group mb-0">
                      <button
                        className="theme-btn"
                        type="submit"
                        disabled={isSubmitting}
                        style={{
                          opacity: isSubmitting ? 0.7 : 1,
                          cursor: isSubmitting ? "not-allowed" : "pointer",
                        }}
                      >
                        {isSubmitting ? "Sending..." : "SEND MESSAGE"}{" "}
                        <span className="la la-caret-right" />
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* CONTACT IMAGE */}
          <div className="col-lg-5 ml-auto">
            <div className="contact-img contact-tilt">
              <img
                src="assets/images/contact-img.png"
                alt="Contact"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </div>
          </div>
        </div>

        {/* ADDRESS */}
        <div className="row contact-address" style={{ marginTop: "40px" }}>
          <div className="col-lg-12">
            <div className="contact-heading">
              <h3 className="contact__heading">Address</h3>
            </div>
          </div>
          <div className="col-lg-9 col-sm-12">
            <div className="contact-card">
              <p className="contact__text">
                <span>
                  <i className="la la-map-marker"></i> Flat 6, East Cliff Manor,
                  45, Christchurch Road, Bournemouth BH1 3PH, United Kingdom
                </span>{" "}
                <span>
                  <i className="la la-map-marker"></i> 7/118/40, Sri Ram Avenue,
                  Keeranatham, Coimbatore - 641035
                </span>{" "}
                <span>
                  <i className="la la-phone"></i>{" "}
                  <a href="tel:+15622865863">+1 562-286-5863</a>
                </span>{" "}
                <span>
                  <i className="la la-whatsapp"></i>{" "}
                  <a href="https://wa.me/919445386422">+91 9445386422</a>
                </span>{" "}
                <span>
                  <i className="la la-envelope-o"></i>{" "}
                  <a href="mailto:orders@dotemb.in">orders@dotemb.in</a>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
